import * as React from 'react'

function IconEmptyAvatar(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={117}
      height={117}
      viewBox="0 0 117 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M58.498 116.997c32.308 0 58.499-26.19 58.499-58.499C116.997 26.191 90.807 0 58.498 0 26.191 0 0 26.19 0 58.498c0 32.308 26.19 58.499 58.498 58.499z"
        fill="#219321"
        fillOpacity={0.15}
      />
      <path
        d="M19.522 75.081c-.147 4.1 3.1 7.67 7.197 7.906.212.013.421.016.63.01 1.936-.046 3.728.994 4.578 2.73 5.08 10.361 15.4 15.86 25.806 16.187 10.522.023 21.125-5.234 26.5-15.628A4.255 4.255 0 0188.418 84c.134.013.265.022.402.029 4.08.193 7.683-2.972 7.99-7.046a7.647 7.647 0 00-7.496-8.233h-.017c-.8-.013-1.47-.611-1.51-1.412-1.063-21.919-14.893-33.29-28.906-33.627-14.007-.134-28.2 10.753-30.011 32.594a1.538 1.538 0 01-1.56 1.406h-.016c-4.172-.069-7.625 3.214-7.772 7.37z"
        fill="#fff"
      />
      <path
        d="M29.824 74.41a.543.543 0 00.366-.951c-.12-.104-2.994-2.57-7.931-1.51a.545.545 0 00.228 1.066c4.375-.935 6.88 1.174 6.984 1.265a.582.582 0 00.353.13z"
        fill="#000"
      />
      <path
        d="M23.164 75.729a.545.545 0 00.455-.23c1.537-2.15 3.744-2.31 3.835-2.317.3-.02.53-.275.51-.576a.542.542 0 00-.572-.513c-.114.006-2.809.18-4.662 2.772a.544.544 0 00.127.759c.092.069.2.105.307.105zM85.779 75.353a.552.552 0 00.353-.121c.108-.089 2.68-2.112 7.023-1.03a.546.546 0 00.265-1.056c-4.898-1.226-7.854 1.14-7.978 1.242a.541.541 0 00-.075.765.549.549 0 00.412.2z"
        fill="#000"
      />
      <path
        d="M92.393 76.893a.543.543 0 00.461-.847c-1.765-2.652-4.453-2.917-4.567-2.926a.538.538 0 00-.589.493.545.545 0 00.494.589c.095.01 2.292.245 3.757 2.445a.54.54 0 00.444.246zM57.161 80.447a.544.544 0 00.193-1.056c-4.228-1.514-4.486-2.24-4.496-2.374-.02-.294 1.063-.867 1.71-1.207.994-.523 2.122-1.118 2.684-1.961 1.678-2.521 1.1-12.156 1.027-13.248a.547.547 0 00-.579-.507.543.543 0 00-.506.578c.186 2.861.402 10.698-.847 12.572-.409.615-1.406 1.14-2.285 1.602-1.213.64-2.361 1.242-2.292 2.25.062.895.974 1.804 5.218 3.321.055.02.114.03.173.03zM55.402 85.047c5.653.094 6.588-4.927 6.598-4.98a.545.545 0 00-1.075-.19c-.033.18-.828 4.274-5.703 4.071-.278-.003-.552.223-.565.523-.013.301.222.553.523.566.075.006.15.01.222.01zM44.53 72.195c.026-1.502-.646-2.731-1.5-2.745-.854-.015-1.566 1.191-1.592 2.694-.025 1.502.647 2.731 1.5 2.745.855.015 1.568-1.191 1.593-2.694zM73.091 72.673c.026-1.502-.646-2.731-1.5-2.746-.854-.014-1.567 1.192-1.592 2.694-.025 1.503.646 2.732 1.5 2.746.855.015 1.567-1.192 1.593-2.694z"
        fill="#000"
      />
      <path
        d="M89.31 68.751s15.556-1.49 13.255-15.066c-2.302-13.575-7.236-12.172-10.067-20.549-2.832-8.376-15.952-15.739-30.763-10.632-14.811 5.107-24.813-6.663-34.723-3.407-9.91 3.257-2.282 11.417-3.988 14.811-1.707 3.394-8.135 5.218-6.484 13.28 1.651 8.064 5.362 21.91 11.502 20.347 5.183-1.317 5.372-21.392 13.873-24.077 7.795-2.462 18.708 9.256 33.003 4.777 1.932-.605 3.907.785 4.024 2.809.367 6.418 2.188 17.547 10.368 17.707z"
        fill="#F4BA27"
      />
      <path
        d="M77.405 66.26c.089 0 .18-.02.265-.062a.545.545 0 00.226-.736c-.036-.068-3.75-6.892-11.077-5.202a.544.544 0 10.245 1.063c6.52-1.507 9.835 4.59 9.867 4.653a.553.553 0 00.474.284zM36.988 65.309a.541.541 0 00.48-.272c.144-.248 3.574-6.039 10.018-4.319a.544.544 0 10.281-1.053c-7.261-1.935-11.204 4.761-11.243 4.83a.544.544 0 00.464.814z"
        fill="#000"
      />
      <path
        d="M79.26 82.66c.37-1.642-2.634-3.718-6.71-4.637-4.076-.92-7.68-.334-8.05 1.308-.37 1.642 2.633 3.718 6.71 4.637 4.076.92 7.68.334 8.05-1.308zM43.27 83.47c4.07-.946 7.06-3.042 6.68-4.681-.382-1.64-3.99-2.201-8.06-1.255-4.07.947-7.06 3.043-6.678 4.682.38 1.639 3.99 2.2 8.059 1.254z"
        fill="#FFDEDE"
      />
    </svg>
  )
}

export default IconEmptyAvatar
